// users-api's User, as served by flexinet-users-api origin/master
// (src/appsync-api/src/schema/features/users.graphql), for reference:
//
//   type User {
//       accountId: String          accountAdmin: String       address: String
//       birthDate: String          email: AWSEmail            emailVerified: String
//       enabled: String            familyName: String         gender: String
//       givenName: String!         locale: String             middleName: String
//       name: String               nickname: String           phoneNumber: String
//       phoneNumberVerified: String  picture: String          profile: AWSURL
//       status: String             username: ID!              website: AWSURL
//       zoneInfo: String           sub: ID!
//       created: AWSDateTime       updated: AWSDateTime
//   }
//   type UserConnection { items: [User]  nextToken: String }
//
// ⚠️ accountId is custom:account_id and accountAdmin is custom:account_admin.
// Directory shows both and never writes them (services/userInput.ts, FNP-2015).
// The verified flags arrive as the STRINGS "true"/"false".
//
// `created` is optional in the schema but Cognito sets UserCreateDate on every
// user, so it is the default sort key; useTableSort puts any missing value last.

export type UserDimension = { name: string, value: string }

export enum UserStatus {
    UNCONFIRMED = 'UNCONFIRMED',
    CONFIRMED = 'CONFIRMED',
    EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
    RESET_REQUIRED = 'RESET_REQUIRED',
    FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD'
}

export type User = {
    id: string,
    accountId?: string,
    accountAdmin?: string,
    address?: string,
    birthDate?: string,
    email?: string,
    emailVerified?: string
    enabled?: string,
    familyName?: string,
    gender?: string,
    givenName?: string,
    locale?: string,
    middleName?: string,
    name?: string,
    nickname?: string,
    phoneNumber?: string,
    phoneNumberVerified?: string,
    picture?: string,
    profile?: string,
    status: string,
    username?: string,
    website?: string,
    zoneInfo?: string,

    sub?: string,

    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    managedByUsername?: string
    managedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export type UserConnection = {
    items: User[],
    nextToken?: string | null,
}

export type ListUsers = {
    listUsers: UserConnection
}

// users-api's UsersFilterInput, plus `status`, which the module filters on
// client-side over the loaded pages.
export type UsersFilter = {
    email?: string,
    sub?: string,
    accountId?: string,
    status?: string,
}

export type GetUser = {
    getUser: User
}

export type CreateUser = {
    createUser: User
}

export type UpdateUser = {
    updateUser: User
}

export type DeleteUser = {
    deleteUser: string
}

export type UserRecordFormProps = {
    record: User,
    // Returns the save's promise: the form and drawer await it (FNP-2015).
    handleSubmit: (values: User) => Promise<unknown>
    handleCancel: () => void
}
